<template>
  <div
    v-closable="{ handler: deactivateSearch }"
    class="search-form"
    @click="activateSearch"
  >
    <search-input
      v-model="queryString"
      :min-query-length="3"
      :activated="activated"
      @change="search"
      @increment-cursor="incrementCursor"
      @decrement-cursor="decrementCursor"
      @press-enter="onPressEnter"
      @escape="deactivateSearch"
      @search-focus="activateSearch"
    />
    <dropdown-menu
      :search-results="searchResults"
      :query-string="queryString"
      :zero-results-found="zeroResultsFound"
      :cursor-index="cursorIndex"
      @click-away="deactivateSearch"
      @filter-change="onFilterChange"
      @hover-over="onHoverOver"
    />
  </div>
</template>

<script>
  import AlgoliaClient from 'lib/storefront/algolia-client';
  import parseRawSearchResult from 'lib/storefront/parse-raw-search-result';
  import SearchInput from './dropdown-search/search-input';
  import DropdownMenu from './dropdown-search/dropdown-menu'

  export default {
    components: {
      SearchInput,
      DropdownMenu
    },
    props: {
      activated: { type: Boolean, required: false, default: false }
    },
    data() {
      const searchClient = new AlgoliaClient({
        algoliaAppId: csConf.algoliaApplicationID,
        algoliaApiKey: csConf.algoliaSearchKey,
        searchIndexNames: [
          {
            displayName: 'Site Wide Search',
            algoliaName: csConf.siteWideSearchIndexName,
            isDefault: true
          }
        ],
        searchOptions: {
          hitsPerPage: 5,
          highlightPreTag: '<strong>',
          highlightPostTag: '</strong>'
        }
      });
      return {
        searchClient,
        queryString: '',
        facetFilters: '',
        searchResults: [],
        zeroResultsFound: false,
        cursorIndex: -1
      }
    },
    methods: {
      activateSearch() {
        this.$emit('toggle-search', true);
      },
      deactivateSearch() {
        this.queryString = '';
        this.clear();
        this.$emit('toggle-search', false);
      },
      onFilterChange(filterValue) {
        this.facetFilters = filterValue;
        this.search();
      },
      incrementCursor() {
        const indexOfLastResult = this.searchResults.length - 1;
        if (this.cursorIndex < indexOfLastResult) {
          this.cursorIndex += 1;
        }
      },
      decrementCursor() {
        if (this.cursorIndex >= 0) {
          this.cursorIndex -= 1;
        }
      },
      onHoverOver(searchResultIndex) {
        this.cursorIndex = searchResultIndex;
      },
      onPressEnter() {
        if (this.cursorIndex > -1) {
          window.location = this.searchResults[this.cursorIndex].permalink;
        } else {
          window.location = `/search?q=${this.queryString}`;
        }
      },
      clear() {
        this.cursorIndex = -1;
        this.zeroResultsFound = false;
        this.searchResults = [];
      },
      search() {
        if (this.queryString.length < 3) {
          this.clear();
        } else {
          const vm = this;
          vm.searchClient.search({
            query: vm.queryString,
            facetFilters: this.facetFilters,
          }).then((content) => {
            vm.zeroResultsFound = content.hits.length === 0;
            vm.searchResults = content.hits.map((rawHit) => {
              return parseRawSearchResult({ rawHit });
            })
          }, (error) => {
            console.log(error);
          });
        }
      }
    }
  };
</script>
